export const TiposAnestesias = {
  local_realizado_pelo_medico_dev: '69b06af8-9627-40c0-86b2-7debfff140f7',
  local_realizado_pelo_medico: 'f275e81c-0806-4a76-970a-eb34e4a5cbfd'
}
